const asm = {
  "भाजपा सदस्यता अभियान - 2024": "বিজেপি সদস্যতা অভিযান - ২০২৪",
  "Select Language": "ভাষা বাচনি কৰক",
  Next: "পৰৱৰ্তী",
  "Enter your mobile number": "আপোনাৰ ম'বাইল নম্বৰ দিয়ক",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "মই নিয়ম আৰু চৰ্তাৱলী স্বীকাৰ কৰিছোঁ, আৰু আগবঢ়াই যোৱাঁতে, মই স্বইচ্ছাৰে বিজেপিৰ সদস্য হ'বলৈ সম্মতি দিছোঁ।",
  "Get OTP": "OTP পাওক",
  "Terms and Conditions": "নিয়ম আৰু চৰ্তাৱলী",
  "You must tick the box to continue, as it is mandatory.":
    "অব্যাহত ৰাখিবলৈ আপুনি বাকচটোত টিক চিহ্ন দিবই লাগিব, ই বাধ্যতামূলক।",
  "Okay, Got it": "ঠিক আছে, বুজিছোঁ",
  "Get OTP": "OTP পাওক",
  "Enter OTP": "OTP দিয়ক",
  "Resend OTP": "OTP পুনৰ পাঠাওক",
  Continue: "আগবঢ়াওক",
  "Fill details": "বিৱৰণ ভৰাওক",
  "Upload Photo": "ফটো আপলোড কৰক",
  "Profile Photo": "প্ৰফাইল ফটো",
  "Mobile number": "ম'বাইল নম্বৰ",
  "Mrs.": "শ্ৰীমতী",
  "Mr.": "শ্ৰীযুত",
  Ms: "কুমাৰী",
  "Full Name*": "সম্পূৰ্ণ নাম *",
  "D.O.B": "জন্ম তাৰিখ",
  Age: "বয়স",
  Gender: "লিংগ",
  Female: "মহিলা",
  Male: "পুৰুষ",
  Other: "আন",
  "Email Id": "ই-মেইল আইডি",
  "Add address": "ঠিকনা যোগ কৰক",
  "House/ Flat/ Floor No.": "ঘৰ/ ফ্লেট/ মজলাৰ নম্বৰ",
  "Current address PIN code": "বৰ্তমান ঠিকনা PIN ক’ড",
  "District*": "জিলা*",
  State: "ৰাজ্য",
  "Assembly constituency (AC)": "বিধানসভা সমষ্টি (AC)",
  "Tell us about your location": "আপোনাৰ স্থানৰ বিষয়ে আমাক জনাওক",
  "It will assist us in locating other members in your area.":
    "ই আপোনাৰ এলেকাত আন সদস্যসকলৰ স্থান চিনাক্ত কৰিবলৈ আমাক সহায় কৰিব।",
  "Your address as fetched": "আপোনাৰ ঠিকনা যি পোৱা হৈছে",
  "Referral code": "পৰামৰ্শ ক’ড",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "মই প্ৰমাণ দিছোঁ যে উপৰোক্ত দিয়া তথ্য শুদ্ধ আৰু ইয়াত কোনো ভুল নাই। মই জানো যে সকলো পঢ়াওঁক",
  Save: "সংৰক্ষণ কৰক",
  Select: "বাচনি কৰক",
  Camera: "কেমেৰা",
  or: "বা",
  Gallery: "গ্যালাৰী",
  "Support format : Jpeg, Png, Pdf": "সমৰ্থিত ফৰ্মেট : Jpeg, Png, Pdf",
  Cancel: "বাতিল",
  "Select location": "স্থান বাচনি কৰক",
  "Provide location": "স্থান প্ৰদান কৰক",
  "Search results": "অনুসন্ধান ফলাফল",
  "Search for a building, street name or..": "এখন ভবন, পথৰ নাম বা.. সন্ধান কৰক",
  "Your address as fetched": "আপোনাৰ ঠিকনা যি পোৱা হৈছে",
  "Locate me": "মোক স্থান দিওক",
  "Confirm location": "স্থান নিশ্চিত কৰক",
  "Congratulations !": "অভিনন্দন !",
  "Your primary Id is -": "আপোনাৰ প্ৰাথমিক আইডি হৈছে -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "আপোনাৰ তথ্য উন্নত কৰাৰ, আপোনাৰ আইডি কাৰ্ড পোৱাৰ, আৰু আনক প্ৰাথমিক সদস্য হিচাপে যোগদান কৰিবলৈ পৰামৰ্শ কৰাৰ বাবে Bjp.org/membership ত প্ৰৱেশ কৰক।",
  "ID CARD": "আইডি কাৰ্ড",
  "You can download your generated ID Card":
    "আপোনাৰ সৃষ্ট আইডি কাৰ্ড ডাউনলোড কৰিব পাৰে",
  Download: "ডাউনলোড কৰক",
  "Go to dashboard": "ডেছব’ৰ্ডলৈ যাওক",
  "View your profile": "আপোনাৰ প্ৰফাইল চাওক",
  "Refer and add member": "পৰামৰ্শ কৰক আৰু সদস্য যোগ কৰক",
  Share: "শ্বেয়াৰ কৰক",
  "To update your additional details and refer more member, please click here.":
    "আপোনাৰ অতিৰিক্ত বিৱৰণসমূহ আপডেট কৰাৰ আৰু অধিক সদস্যক পৰামৰ্শ কৰাৰ বাবে, অনুগ্ৰহ কৰি ইয়াত ক্লিক কৰক।",
  "Bharatiya Janata Party": "ভাৰতীয় জনতা পাৰ্টি",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6এ, দীনদয়াল উপাধ্যায় মার্গ, নতুন দিল্লী - ১১০০০২",
  Name: "নাম",
  State: "ৰাজ্য",
  "Membership Number": "সদস্যপদ নম্বৰ",
  "QR Code": "QR ক’ড",
  "Please select a year between 1930 and 2006.":
    "অনুগ্ৰহ কৰি ১৯৩০ চনৰ পৰা ২০০৬ চনৰ ভিতৰত এটা বছৰ বাছি লওক।",
  "Please enter a valid email address.": "অনুগ্ৰহ কৰি এটা বৈধ ইমেইল দিয়ক।",
  "Please enter 6-digit PIN code.": "অনুগ্ৰহ কৰি ৬ অংকৰ পিন ক'ড দিব।",
  "10-digit mobile number.": "১০ অংকৰ মোবাইল নম্বৰ।",
  "Please enter a 10-digit mobile number.":
    "অনুগ্ৰহ কৰি ১০ অংকৰ মোবাইল নম্বৰ প্ৰৱেশ কৰক।",
  "Please enter your name.": "অনুগ্ৰহ কৰি আপোনাৰ নাম লিখক।",
  "I pledge and willing to receive regular updates from BJP":
    "মই প্ৰতিশ্ৰুতি দিছো যে বিজেপিৰ পৰা নিয়মীয়াকৈ আপডেট লাভ কৰিবলৈ ইচ্ছুক আছো ",
  "Get Verification Code": "প্ৰমাণীকৰণ কোড লাভ কৰক",
  "Enter Verification Code": "সত্যাপন ক'ড দিয়ক",
  "Resend Verification Code": "প্ৰমাণীকৰণ কোড পুনৰ প্ৰেৰণ কৰক",
  "Provide Details": "বিৱৰণ প্ৰদান কৰক",
  Upload: "আপলোড কৰক",
  Ok: "ঠিক আছে",
  Calendar: "কেলেণ্ডাৰ",
  "Full Address": "সম্পূৰ্ণ ঠিকনা",
  "Privacy policy": "গোপনীয়তা নীতি",
  Disclaimer: "অস্বীকাৰ",
  "Contact us": "আমাৰ সৈতে যোগাযোগ কৰক",
  Save: "চেভ কৰক",
  "Your primary member ID": "আপোনাৰ প্ৰাথমিক সদস্য পদৰ আইডি",
  "Membership Card": "সদস্যতা কাৰ্ড",
  "Your Unique Referral code": "আপোনাৰ অনন্য ৰেফাৰেন্স ক'ড",
  "Invite and add member": "নিমন্ত্ৰণ প্ৰেৰণ কৰক আৰু সদস্য যোগ কৰক",
  Share: "শ্বেয়াৰ",
  "Click below to add more details, donate and add other members to BJP":
    "আপোনাৰ বিষয়ে অধিক শ্বেয়াৰ কৰিবলৈ, দান কৰিবলৈ, আৰু আন সদস্যসকলক বিজেপিত যোগদান কৰাবলৈ তলত ক্লিক কৰক।",
  "Update your details": "আপোনাৰ বিৱৰণ আপডেট কৰক",
  "Add Referral Details": "প্ৰসংগ বিৱৰণ যোগ কৰক",
  "Referred by (name)": "ৰেফাৰ কৰিছে (নাম)",
  "Referred by (mobile number)": "ৰেফাৰ কৰিছে (মোবাইল নম্বৰ)",
  Capture: "ফটো তোলক",
  "Close Camera": "কেমেৰা বন্ধ কৰক",
  Uploading: "আপলোড কৰা হয় আছে",
  "Your Unique Referral Link": "আপোনাৰ ইউনিক ৰেফাৰেল লিংক",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "আপুনি আজিৰ বাবে সৰ্বাধিক OTP প্ৰচেষ্টাত উপনীত হৈছে। অনুগ্ৰহ কৰি কাইলৈ পুনৰ চেষ্টা কৰক",
  Miss: "শ্ৰী",
  "Full Name": "সম্পূৰ্ণ নাম",
  "OTP limit reached for today. Please try again tomorrow":
    "আজিৰ বাবে অ’টিপি সীমা সমাপ্ত হ’ল। অনুগ্ৰহ কৰি কাইলৈ ​​পুনৰ চেষ্টা কৰক",
  ": is not a Primary Member, Only Primary Members can refer":
    ": এজন প্ৰাথমিক সদস্য নহয়, কেৱল প্ৰাথমিক সদস্যসকলেহে বাকী থকা প্ৰচেষ্টাসমূহ উল্লেখ কৰিব পাৰিব",
  "Please enter valid fullname": "অনুগ্ৰহ কৰি বৈধ সম্পূৰ্ণনাম দিয়ক",
  Upload: "আপলোড কৰক",
};

export default asm;
